export interface ICreatePendAnnotationRequest {
  message: string;
  entityType: string;
  entityId: string;
}

export const createPendAnnotationRequest = (pendId: number | string, commentText: string): ICreatePendAnnotationRequest => ({
  message: commentText,
  entityType: "Pend",
  entityId: pendId.toString(),
});
